import React from "react";
import "./Footer.css";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaFacebook,
  FaYoutube,
  FaInstagram
} from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Contact Details */}
        <div className="footer-section">
          <h3 className="section-title">Our Contact details</h3>

          <div className="logo-row">
            <img
              src="/logo5.png"
              alt="Udhavum Ullangal Logo"
              className="footer-logo"
            />
            <div className="logo-text">
              <h4>OUR COUNTRY OUR PEOPLE</h4>
              <p>FOUNDATION</p>
            </div>
          </div>

          <p className="address">
            No.4/186, P No 24, Venkateshwara Avenue Mathana Puram, Mudichur, Chennai – 600048.  
          </p>

          <p className="timing">Phone numbers: (24 hours Available)</p>

          <p className="phone"><FaPhoneAlt /> 044-45062816</p>
          <p className="phone"><FaPhoneAlt /> +91-9840693733</p>
          <p className="phone"><FaPhoneAlt /> +91-9384149383</p>
          <h1 className="certificate"><strong>CSR Certificate No : </strong>CSR 00099135</h1>

        </div>

        {/* Policies */}
        <div className="footer-section">
          <h3 className="section-title">Policies & Certificates</h3>
          <ul className="footer-links">
            <li><a href="/terms">Terms Of Use</a></li>
            <li><a href="/privacy">Privacy Policy</a></li>
            <li><a href="/refund">Refund Policy</a></li>
            <li><a href="/certificates/80G-Certificate.pdf"
      download
      target="_blank"
      rel="noopener noreferrer"
      className="footer-link">80G-Certificate</a></li>
            <li><a href="/certificates/12A -certificate.pdf"
      download
      target="_blank"
      rel="noopener noreferrer"
      className="footer-link">12A -Certificate</a></li>
          </ul>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3 className="section-title">Quick Links</h3>
          <ul className="footer-links">
            <li><a href="/">Home</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/ourprojects">Our Projects</a></li>
            <li><a href="/donate">Get Involved</a></li>
            <li><a href="/contact">Contact</a></li>
            <li><a href="/adminlogin">Admin</a></li>
          </ul>
        </div>

        {/* Email */}
        <div className="footer-section">
          <h3 className="section-title">Email</h3>
          <p className="email"><FaEnvelope /> namnadunammakkall@gmail.com</p>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>
          Copyrights © 2025 
          <span className="highlight"> OurCountry OurPeople Foundation.</span> 
          All Rights Reserved.
        </p>

        <div className="social-icons">
          <a href="https://www.facebook.com/namnadu.nammakall.arakattalai"><FaFacebook /></a>
          <a href="https://www.youtube.com/channel/UC_7H2xW5LbEV4QIS8XjoMMA"><FaYoutube /></a>
          <a href="https://www.instagram.com/namnadu_nammakall_arakattalai?igsh=eXQ5MnkybmdpMDl4&utm_source=qr"><FaInstagram /></a>
          <a href="mailto:namnadunammakkall@gmail.com"><FaEnvelope /> </a>
        </div>
      </div>
    </footer>
  );
}
